import { configureAxios, getAxios } from '@parchment/oauth2-axios';
import { ADDRESS_VERIFICATION_API_KEY, MEMBER_SERVICE_API_KEY,
    PARCHMENT_IDENTITY_PROVIDER_KEY } from '../../actions';

configureAxios({
    config: { baseURL: window.config.service.parchmentIdentityProviderUrl },
    name: PARCHMENT_IDENTITY_PROVIDER_KEY,
    onGetAccessToken: getAccessToken
});

configureAxios({
    config: { baseURL: window.config.service.memberServiceApiUrl },
    name: MEMBER_SERVICE_API_KEY,
    onGetAccessToken: getAccessToken
});

configureAxios({
    config: { baseURL: window.config.service.addressVerificationApiUrl },
    name: ADDRESS_VERIFICATION_API_KEY,
    onGetAccessToken: getAccessToken
});

async function getAccessToken() {
    const response = await getAxios().get('/u/auth/api-token');
    return response.data?.access_token;
}
